import { Vector } from '@moleculeone/types';

interface ReferenceReactionTreeLabelProps {
  point: Vector;
  scale: number;
  padding: number;
  reactionId: string;
  reactionData: {
    substrateSmiles: string;
  };
  labelMap: Record<string, string>;
}

export function ReferenceReactionTreeLabel(props: ReferenceReactionTreeLabelProps) {
  const { point, reactionId, reactionData, labelMap } = props;

  if (!labelMap[reactionId]) {
    return null;
  }

  const xModifier = reactionData.substrateSmiles.length > 1 ? 0 : -30;
  const commonPointProps = {
    x: point[0] + xModifier,
    y: point[1],
  };

  return (
    <g>
      <circle cx={commonPointProps.x} cy={commonPointProps.y} r={70} fill="white" stroke="black" strokeWidth={1} />
      <text x={commonPointProps.x} y={commonPointProps.y + 25} textAnchor="middle" fontSize={80}>
        {labelMap[reactionId]}
      </text>
    </g>
  );
}
